<template>
  <div id="user-search" class="waiting-table">
    <div class="row">
      <div class="col-md-12 inline-div">
        <div class="inline-div">
          <h5 class="mr-5">{{ $t("events.listEvents.guestSelected") }}: {{this.selected.length}}</h5>

          <button
            class="btn-download mr-5"
            @click="downloadTable"
          >{{ $t("events.listEvents.donwloadBtn") }}</button>
          <button
            @click="multipleConfirmEvents"
            :disabled="selected.length === 0"
            class="btn-download"
          >{{ $t("events.listEvents.markAsConfirmed") }}</button>
        </div>
      </div>
    </div>
    <!-- v-on:filter="listenTo" -->
    <v-server-table
      :columns="table_options.columns"
      :options="table_options.options"
      ref="userTable"
    >
      <!-- Select All -->
      <template #filter__select>
        <label for="toggleAll">{{ $t("users.search.table.toggleAll") }}</label>
        <br />
        <input
          type="checkbox"
          name="toggleAll"
          id="toggleAll"
          v-model="allChecked"
          v-on:click="selectAll"
        />
      </template>
      <!-- Checks -->
      <template #select="props">
        <input
          type="checkbox"
          :name="`select${props.row.id}`"
          :id="`select${props.row.id}`"
          :value="props.row.id"
          v-model="selected"
        />
      </template>
      <template #confirmedBtn="props">
        <button
          class="confirmed-btn"
          @click="openModal(props.row)"
        >{{ $t("events.listEvents.confirmBtn") }}</button>
      </template>
    </v-server-table>
    <Modal v-if="modalActive || busyModalActive" @closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{ $t("events.guest.modal.atention") }}</h6>
      </template>
      <template>
        <p v-if="modalActive">{{ $t("events.listEvents.markAsEnterAlert") }}</p>
        <p v-if="busyModalActive">{{ $t("events.eventBusyModal.alert") }}</p>
        <p v-if="modalActive || busyModalActive">{{ $t("events.listEvents.sureText") }}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn mr-4" @click="closeModal">
            {{
            $t("map.benefits.list.modal.cancel")
            }}
          </span>
          <span
            type="control button"
            class="control entered-btn"
            @click="changeUserToConfirmedTable(userInfo)"
          >{{ $t("events.listEvents.markAsConfirmed") }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
import API_SERVICE from "@/lib/api/Events.js";
import lodash from "lodash";
import { mapState, mapMutations } from "vuex";
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");
import Json2Csv from "vue-json-to-csv";

export default {
  components: {
    Modal,
    Json2Csv
  },
  props: ["quantity"],
  data: function() {
    return {
      users: null,
      selected: [],
      allChecked: false,
      usersParams: {},
      dinamycObj: {},
      filters: [],
      arrayDinamycObj: [],
      modalActive: false,
      userInfo: null,
      csvData: null,
      busyModalActive: false,
      dictionary: {
        name: this.$t("users.search.table.headings.name"),
        lastName: this.$t("users.search.table.headings.lastName"),
        mothersLastName: this.$t("users.search.table.headings.mothersLastName"),
        UO: this.$t("users.search.table.headings.UO"),
        companyEmail: this.$t("users.search.table.headings.email"),
        birthdate: this.$t("users.search.table.headings.birthdate"),
        gender: this.$t("users.search.table.headings.gender"),
        admissionDate: this.$t("users.search.table.headings.admissionDate"),
        workingShift: this.$t("users.search.table.headings.workingShift"),
        maritalStatus: this.$t("users.search.table.headings.maritalStatus"),
        numberOfChildren: this.$t(
          "users.search.table.headings.numberOfChildren"
        )
      },
      items: []
    };
  },
  filters: {
    birthdateFormat: function(value) {
      if (value) return moment(value).format("l");
    }
  },
  methods: {
    openModal: function(user) {
      this.userInfo = user;
      if (this.quantity === 0 || this.quantity < 0) {
        this.busyModalActive = true;
      } else {
        this.modalActive = true;
      }
    },
    closeModal: function() {
      this.modalActive = false;
      this.busyModalActive = false;
    },
    async downloadTable() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let id = this.$route.params.id;
        const resp = await api.downloadEventTable(id, "waiting");
        let anchor = document.createElement("a");
        anchor.href = resp.url;
        anchor.target = "_blank";
        anchor.click();
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    },
    async changeUserToConfirmedTable(userInfo) {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const resp = await api.markAsConfirmed(userInfo.id);
        this.$refs.userTable.refresh();
        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
      }
    },
    async multipleConfirmEvents() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        for (let index = 0; index < this.selected.length; index++) {
          const resp = await api.markAsConfirmed(this.selected[index]);
        }
        this.$refs.userTable.refresh();
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        this.selected = [];
        this.allChecked = false;
      }
    },
    selectAll: async function() {
      try {
        if (!this.allChecked) {
          let clone = this.lodash.cloneDeep(this.$refs.userTable._data.query);
          //Poner filtros
          for (const key in clone) {
            if (clone[key] === "") {
              delete clone[key];
            }
          }

          let data = {
            filter: "waiting"
          };
          let appendArray = [];
          let id = this.$route.params.id;
          const resp = await api.getGuestsByStatus(data, id);

          appendArray = resp.users.result.map(key => key.id);
          this.selected = this.selected.concat(appendArray);
          this.selected = this.cleanRepeatedControlsNumbers(this.selected);
        } else {
          this.selected = [];
        }
      } catch (error) {
        throw error;
      }
    },

    cleanRepeatedControlsNumbers(selected = []) {
      return this.lodash.uniqBy(selected, function(e) {
        return e;
      });
    }
  },
  computed: {
    appLang: function() {
      return this.$store.getters["settings/currentLang"];
    },
    userTable: function() {
      return this.$refs.userTable;
    },
    table_columns: function() {
      // if (this.users) return ['select', ...Object.keys(this.users[0])];
      // return null;
      return [
        "select",
        "name",
        "lastName",
        "mothersLastName",
        "uo",
        "companyEmail",
        "birthdate",
        "gender",
        "admissionDate",
        "workingShift",
        "maritalStatus",
        "numberOfChildren",
        "confirmedBtn"
      ];
    },
    table_headings: function() {
      if (this.table_columns) {
        const headings = {};
        this.table_columns.forEach(column => {
          headings[column] = this.$t(`users.search.table.headings.${column}`);
        });
        return headings;
      }
      return null;
    },
    table_filters: function() {
      return this.table_columns.filter(
        column => column !== "select" && column !== "confirmedBtn"
      );
    },
    table_options: function() {
      return {
        columns: this.table_columns,
        options: {
          columnsDropdown: true,
          filterByColumn: true,
          headings: this.table_headings,
          filterable: this.table_filters,
          sortable: [],
          resizableColumns: false,
          perPage: 10,
          columnsClasses: {
            select: "select-column",
            id: "id-column"
          },
          texts: {
            filterBy: "{column}",
            columns: this.$t("users.search.table.column_toggler")
          },
          requestAdapter: function(data) {
            const queries = {};
            queries.page = data.page - 1;
            queries.limit = data.limit;
            queries.query = data.query;
            queries.filter = "waiting";
            return queries;
          },
          requestFunction: async function(data) {
            this.$store.commit("global/SET_LOADING", true);
            try {
              let id = this.$route.params.id;
              const resp = await api.getGuestsByStatus(data, id);

              this.$store.commit("global/SET_LOADING", false);
              this.$store.commit(
                "global/SET_RESP",
                resp.users.busyPlacesResult
              );
              return resp;
            } catch (error) {
              this.$store.commit("global/SET_LOADING", false);
              throw error;
            }
          },
          responseAdapter: function(response) {
            return {
              data: response.users.result,
              count: response.users.subTotal
            };
          }
        }
      };
    }
  },

  mounted() {
    this.$on("vue-tables.userTable.filter", function(data) {});
  }
};
</script>

<style lang="scss" scoped>
.select-btn {
  align-self: center;
  background-color: $black;
  color: $white;
  border: 1px solid $black;
  border-radius: 0;
  padding: 0.5rem 2rem;
  margin: 1rem 0;
}
</style>

<style lang="scss">
#user-search {
  .pull-right {
    float: none;
  }
  .VueTables .dropdown {
    margin: 1rem 0;
  }
  .VueTables .dropdown > button {
    @extend %audi;
    color: $black;
    background-color: transparent;
    border: 1px solid $black;
    border-radius: 0;
    padding: 5px 10px;
  }
  .VueTables .dropdown .dropdown-menu {
    padding: 1rem;
    a {
      color: $black;
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    a > input {
      margin-right: 0.5rem;
    }
    input[type="checkbox"][value="select"] {
      display: none;
    }
  }
  .VueTables__table.table {
    min-width: 100%;
    width: max-content;
  }
  .VueTables__table .select-column {
    position: sticky;
    left: 0;
    text-align: center;
    &:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      background-color: #f2f2f2;
      top: 0;
      left: 0;
      border-collapse: collapse;
    }
  }
  .VueTables__table .select-column > * {
    position: relative;
    z-index: 1;
  }
  .table-striped tbody tr:nth-of-type(odd) > .select-column {
    &:after {
      background-color: #e6e6e6;
    }
  }
  .VueTables__table .id-column {
    max-width: 100px;
  }
  [class$="filter-wrapper"] {
    min-width: 80px;
    max-width: fit-content;
  }
}
.btn-filter {
  background: #bb0a30 !important;
  color: #fff !important;
}
.confirmed-btn {
  background: transparent;
  border: 1px solid #000;
  color: #000;
  padding: 0.5rem;
}
</style>
<style>
.waiting-table .modal-container {
  max-width: 40vw !important;
  min-width: 40vw !important;
}
.waiting-table .controls {
  display: flex;
  justify-content: end;
  align-items: flex-end;
}
.waiting-table .controls .cancel-btn,
.waiting-table .controls .entered-btn {
  cursor: pointer;
}
.btn-download {
  padding: 1rem;
  background: #000;
  color: #fff;
  border: none;
  border-radius: 0px;
}
.inline-div {
  display: flex;
  justify-content: end;
  align-items: center;
  text-align: right;
}
</style>
